import React from 'react';
import {Modal,ModalBody,ModalHeader,Node} from '../';

export interface IModalViewProps {
    galleryCarousel:React.ReactElement;
    modalIsOpen: boolean;
    ontoggle():void;
}

export const  ImagefullView:React.FC<IModalViewProps> =(props:IModalViewProps): React.ReactElement => {
    const body = (
        <Node tag={ModalBody} className='msc-fullview-modal-body'>
            { props.galleryCarousel }
        </Node>
    );

    const modalWindow = (
        <Modal
            autoFocus={true}
            applicationNode={'renderPage'}
            isOpen={props.modalIsOpen}
            toggle={props.ontoggle}
            className={'msc-fullview-modal'}
            zIndex={1050}
        />
    );

    const modalHeader = (
        <ModalHeader toggle={props.ontoggle}/>
    );

    return React.cloneElement(modalWindow, {}, modalHeader,body);
};